import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';
import { colors, LinearProgress, Typography, Select, MenuItem, FormControl } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import WebbeeLogo from '../../../../svg/logos/Webbee';
import { useTranslation } from 'react-i18next';
import TimeDisplay from "../../../../common/TimeDisplay";

const Topbar = ({
                    themeMode,
                    themeToggler,
                    setThemePalette,
                    onSidebarOpen,
                    paletteType,
                }: {
    themeMode: "light" | "dark";
    themeToggler: () => void;
    setThemePalette: (type?: string) => void;
    onSidebarOpen: () => void;
    paletteType: string;
}) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();

    const timeDisplayProps = React.useMemo(() => ({
        themeMode
    }), [themeMode]);

    const handleLanguageChange = (event: any) => {
        i18n.changeLanguage(event.target.value);
    };

    return (
        <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            width={'100%'}
        >
            <Box display={'flex'} alignItems={'center'}>
                <Box marginRight={{ xs: 1, sm: 2 }} sx={{ display: { md: 'none', sm: 'block' } }}>
                    <IconButton onClick={onSidebarOpen} aria-label="Menu">
                        <MenuIcon style={{ color: 'white' }} />
                    </IconButton>
                </Box>
                <Box
                    style={{ textDecoration: 'none', alignItems: "end" }}
                    display={'flex'}
                    gap={1}
                    component="a"
                    href="/"
                    title="Fincome"
                    height={{ xs: 28, md: 32 }}
                >
                    <WebbeeLogo width="100%" height="100%" />
                    <Typography component="h5" variant="h5"
                                sx={{ fontSize: { xs: 14, sm: 20 }, fontWeight: 700, color: 'white' }}>ЭТП</Typography>
                </Box>
            </Box>
            <Box display="flex" alignItems={'center'} gap={1.5} height={40}>
                <Box sx={{ display: { xs: 'none', md: 'flex' } }} alignItems={'center'} gap={1.5}>
                    <Box>
                        <Link
                            underline="none"
                            component="a"
                            href="/page-user-support"
                            sx={{ color: "white" }}
                        >
                            {"Помощь пользователям"}
                        </Link>
                    </Box>
                </Box>

                {/* Десктопная версия выбора языка */}
                <Box
                    sx={{ display: { xs: 'none', md: 'block' } }}
                    width={{ xs: 100 }}
                    textAlign="center"
                >
                    <Link underline={i18n.language === "kk" ? "always" : "none"}
                          style={{ cursor: 'pointer', color: 'white' }}
                          component="a"
                          onClick={() => i18n.changeLanguage("kk")}
                    >
                        KZ
                    </Link>
                    &nbsp;
                    <Link underline={i18n.language === "ru" ? "always" : "none"}
                          style={{ cursor: 'pointer', color: 'white' }}
                          component="a"
                          onClick={() => i18n.changeLanguage("ru")}
                    >
                        RU
                    </Link>
                    &nbsp;
                    <Link underline={i18n.language === "en" ? "always" : "none"}
                          style={{ cursor: 'pointer', color: 'white' }}
                          component="a"
                          onClick={() => i18n.changeLanguage("en")}
                    >
                        EN
                    </Link>
                    &nbsp;
                    <Link underline={i18n.language === "zh" ? "always" : "none"}
                          style={{ cursor: 'pointer', color: 'white' }}
                          component="a"
                          onClick={() => i18n.changeLanguage("zh")}
                    >
                        ZH
                    </Link>
                </Box>

                {/* Мобильная версия выбора языка (выпадающее меню) */}
                <Box
                    sx={{ display: { xs: 'block', md: 'none' } }}
                >
                    <FormControl variant="standard" size="small">
                        <Select
                            value={i18n.language}
                            onChange={handleLanguageChange}
                            displayEmpty
                            sx={{
                                color: 'white',
                                '.MuiSelect-select': {
                                    padding: '2px 24px 2px 8px',
                                    fontSize: '14px'
                                },
                                '.MuiSelect-icon': {
                                    color: 'white'
                                },
                                '&:before, &:after': {
                                    borderColor: 'white'
                                }
                            }}
                        >
                            <MenuItem value="kk">KZ</MenuItem>
                            <MenuItem value="ru">RU</MenuItem>
                            <MenuItem value="en">EN</MenuItem>
                            <MenuItem value="zh">ZH</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Box
                    width={{ xs: 70 }}
                    textAlign="center"
                >
                    <TimeDisplay {...timeDisplayProps} />
                </Box>
            </Box>
        </Box>
    );
};

Topbar.propTypes = {
    onSidebarOpen: PropTypes.func,
    themeToggler: PropTypes.func.isRequired,
    themeMode: PropTypes.string.isRequired,
    setThemePalette: PropTypes.func.isRequired,
    paletteType: PropTypes.string.isRequired,
}

export default Topbar;